import { useState, useEffect } from "react";
import { ShippingItemType, TrackingItemType } from "@/schemas/index";
import { useTrackingService } from "@/services";
import { useNotifications } from "@/app/hook/use-notifications";

export function useModalTrackingViewHook() {
  const [loadingData, setLoadingData] = useState<boolean>(false);
  const [trackingData, setTrackingData] = useState<TrackingItemType>();
  const [shippingItem, setShippingItem] = useState<ShippingItemType>();
  const { fetchTrackingItem } = useTrackingService();
  const notifications = useNotifications();

  const closeModal = () => {
    setShippingItem(undefined);
  };

  const fetchModalTrackingView = (shippingItem: ShippingItemType) => {
    setShippingItem({ ...shippingItem });
  };

  useEffect(() => {
    const fetchTrackingData = async () => {
      try {
        if (!shippingItem?.Id) {
          return;
        }
        setLoadingData(true);
        const trackingData = await fetchTrackingItem(shippingItem.Id);
        setTrackingData(trackingData || undefined);
        setLoadingData(false);
      } catch (error) {
        notifications.show(error as Error);
        setTrackingData(undefined);
        setLoadingData(false);
      }
    };

    if (shippingItem) {
      fetchTrackingData().catch(console.error);
    }
  }, [shippingItem]);

  return {
    loadingData,
    trackingData,
    isOpenModal: !!shippingItem,
    closeModal,
    fetchModalTrackingView,
  };
}
